// extracted by mini-css-extract-plugin
export default {"rating":"sI-z","numberOfStars":"tI-z","count":"uI-z","barGraphSpacing":"vI-z","barGraph":"wI-z"};